/* eslint-disable */
const terms = "He llegit i accepto els {{terms_and_conditions}} de Time Out"
export default {
  'ca-ES': {
    common: {
      NAME_HOLDER: "Nom *",
      LAST_NAME_HOLDER: "Cognom *",
      EMAIL_HOLDER: "Correu electrònic *",
      PASS_HOLDER: "Crear contrasenya *",
      REPEAT_PASS_HOLDER: "Repetir contrasenya *",
      BUTTON_EMAIL_SIGN_UP: "Inicia la sessió amb el teu correu electrònic",

      TERMS_AND_CONDITIONS: "termes i condicions",
      PRIVACY_POLICY: "política de privacitat",

      NEWSLETTER_CONSENT: "Accepto rebre comunicacions rellevants de Time Out, incloses notícies, esdeveniments, ofertes i promocions de clients.",
      TERM_OF_USE: terms,
      TERM_OF_USE_WITH_NEWSLETTERS: "He llegit i accepto els {{terms_and_conditions}} de Time Out, incloent-hi el registre a la newsletter",

      HEADER_TITLE: "Crear un compte de Time Out",
      JOIN_FB: "Uneix-te amb Facebook",
      JOIN_TW: "Uneix-te amb Twitter",
      JOIN_GG: "Uneix-te amb Google",
      JOIN_EM: "Uneix-te amb el teu correu electrònic",
      ALREADY_HAVE: "Ja tens un compte a Time Out?",
      CREATE_ACCOUNT_LOG_IN: "Connecta-t'hi",

      SIGN_IN_TITLE: "Inicia sessió",
      SIGN_IN_FB: "Inicia sessió amb Facebook",
      SIGN_IN_TW: "Inicia sessió amb Twitter",
      SIGN_IN_GG: "Inicia sessió amb Google",
      SIGN_IN_EM: "Inicia sessió amb el teu correu electrònic",
      YOUR_EMAIL: "El teu correu electrònic",
      YOUR_PASSWORD: "La teva contrasenya",
      REMEMBER: "Recorda'm",
      FORGOT: "Oblidar?",
      HAVE_ACCOUNT_YET: "Encara no tens compte de Time Out?",
      JOIN_HERE: "Uneix-te aquí",
      ALMOST_THERE: "Gairebé hi ets",

      FORGOT_HEADER: "Has oblidat la contrasenya?",
      FORGOT_SUBTITLE: "Cap problema. Posa el teu correu electrònic aquí a sota i t'enviarem un enllaç per a restaurar la contrasenya.",
      SEND_LINK: "Envia l'enllaç",

      RECEIVE_EMAIL: "Gràcies, aviat rebràs un correu electrònic",
      MANAGE_ACCOUNT: "Administra el teu compte",
      EDIT_DETAILS_HERE: "Pots editar els detalls del teu compte aquí",
      FIRST_NAME: "Nom",
      LAST_NAME: "Cognom",
      SCREEN_NAME: "Nom del perfil",
      EMAIL: "Correu electrònica",
      ACCOUNT_DETAILS: "Nom del compte",
      PASSWORD: "Contrasenya",
      SAVE_CHANGES: "Desa els canvis",
      UPLOAD_PIC: "Puja una nova foto de perfil",
      CHOOSE_PHOTO: "Escull una foto del teu dispositiu. El pes màxim és de 2 MB.",
      CLOSE_ACCOUNT: "Tanca el compte",
      PASSWORD_BELOW: "Pots canviar la teva contrasenya aquí a sota.",
      CURRENT_PASSWORD: "Contrasenya actual",
      NEW_PASSWORD: "Nova contrasenya",
      REPEAT_PASSWORD: "Repeteix la nova contrasenya",

      OOPS: "Vaja,",
      ERROR_404_OCCURED: "S'ha produït un error…",
      ERROR_404_INFO: "Hem mogut la pàgina o bé ja no existeix.",
      ERROR_500_TITLE: "El servidor ha tornat a ",
      SMTH_BROKEN: "Alguna cosa no funciona.",
      INTERNAL_RED: "500 Internal Server Error",
      LET_KNOW_RED: "Sisplau, explica'ns què estaves fent quan ha succeït l'error. Ho arreglarem tan ràpid com sigui possible. Disculpa pels inconvenients que t'hem pogut causar.",
      ERROR_500_INFO: "what you were doing when this error occurred. We will fix it as soon as possible. Sorry for any inconvenience caused.",

      EMAIL_ERROR: "Si us plau, introdueix una contrasenya",
      FIRST_NAME_ERROR: "Si us plau, introdueix el seu nom",
      LAST_NAME_ERROR: "Si us plau, introdueix el seu cognom",
      TERM_OF_USE_ERROR: "Heu d'acceptar els nostres termes d'ús",
      SIGN_IN_VALIDATION_ERROR: "Correu electrònic o contrasenya incorrectes. Sisplau, torna-ho a provar",
      ACCOUNT_PASSWORDS_VALIDATION: "La contrasenya no coincideix",
      WAS_IT: "Ha sigut alguna cosa que hem fet?",
      DELETE_ACCOUNT_TEXT: "Ens sap greu que vulguis esborrar el teu compte. Si hi ha alguna cosa que t'hagi fet marxar",
      DELETE_ACCOUNT: "Esborrar compte",
      CANCEL: "Cancel·la",

      UPDATE_PASSWORD: "Actualitzi la contrasenya",
      PASSWORD_UPDATE_SUCCESS: "La teva contrasenya ha estat actualitzada",
      ERROR_PASSWORD_LENGTH: "La contrasenya ha de contenir com a mínim 6 caràcters",

      ERROR_MISSING_SITE_PARAMETER: "Falta el paràmetre d'aplicació requerit: site",
      ERROR_ALREADY_REGISTERED: "Ja esteu registrat mitjançant el registre d’email. Inicieu la sessió mitjançant {{email}}",
    },
    'es-barcelona': { TERM_OF_USE: terms, },
    'es-madrid': { TERM_OF_USE: terms, },
    'es-girona': { TERM_OF_USE: terms, },
  }
}



// WEBPACK FOOTER //
// ./translations/ca-ES.js